import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

//@angular/material
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login/login.component';
import { HomeComponent } from './home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { PrivateRoutingModule } from './private/private-routing.module';
import { NgxsModule } from '@ngxs/store';
import { LocalSettingsState } from '../lib/services/local-settings.state';
import { OAuthLoginComponent } from './login/o-auth-login/o-auth-login.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { ConfigService } from '../lib/services/config.service';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    OAuthLoginComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    MatListModule,
    AppRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    MatIconModule,
    PrivateRoutingModule,
    NgxsModule.forRoot([LocalSettingsState]),
    MatProgressSpinnerModule,
    MatExpansionModule,
  ],
  providers: [
    ConfigService,
    provideFirebaseApp((injector) =>
      initializeApp(injector.get(ConfigService).firebase),
    ),
    provideFirestore((injector) =>
      getFirestore(injector.get(ConfigService).firebase.databaseId),
    ),
    provideAuth(() => getAuth()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
